import type { FlowFieldsV2Fragment } from '~/graphql/types';
import { reportAndThrow } from '~/util/reportAndThrow';

/**
 * RETURNS DIRECT CHILDREN IDS FOR EACH ACTION
 * CURRENTLY ONLY IFELSE HAS 2 CHILDREN, THE REST HAVE 1 CHILD AT MOST.
 *
 * Iterate over each action and assign child ids to all actions.
 * The child ids are the ids of the actions that are direct children of the current action.
 *
 * If an action has no children, return empty array for childrenIds.
 * The order of the children is not guaranteed.
 *
 * @param actions
 * @returns
 */
const getChildIdsMapByAction = (
  actions: FlowFieldsV2Fragment['Actions'],
): {
  [id: string]: Array<string>;
} => {
  const startAction = actions.find(
    action => action.__typename === 'FlowV2_Action_Start',
  );

  if (!startAction) {
    return reportAndThrow('Start action missing');
  }

  const result: {
    [id: string]: Array<string>;
  } = {};

  for (const action of actions) {
    if ('parentIds' in action) {
      const parentIds = action.parentIds;

      for (const parentId of parentIds) {
        const prevChildrenIds = result[parentId] || [];
        result[parentId] = [...new Set([...prevChildrenIds, action.id])];
      }
    }
  }

  return result;
};

export default getChildIdsMapByAction;
